/**
 *
 * App
 *
 * This component is the skeleton around the actual pages, and should only
 * contain code that should be seen on all pages. (e.g. navigation bar)
 */

import { Helmet } from 'react-helmet-async';
import { Route, Switch } from 'react-router-dom';

import { ConnectedRouter } from 'connected-react-router';

import { history } from 'appRedux/store';

import { GlobalStyle } from '../styles/global-styles';
import {
  AppPage,
  CancelRecurringPage,
  CancelSuccessPage,
  ChangeCardPage,
  ChangeCardSuccessPage,
  IframeBoxPage,
  RedirectToLogin,
  RedirectToOldCongrant,
  RedirectToOldCongrantReceipt,
  RedirectToPaymentForm,
  RePaymentPage,
  RePaymentSuccessPage,
} from './pages/Loadable';
import { NotFoundPage } from './pages/NotFoundPage/Loadable';

export function App() {
  return (
    <>
      <GlobalStyle />
      <ConnectedRouter history={history}>
        <Helmet>
          <meta name="app-version" content={process.env.REACT_APP_VERSION || '-'} />
        </Helmet>
        <Switch>
          <Route path={process.env.PUBLIC_URL + '/project_iframe/:congrant_id/:project_id'}>
            <IframeBoxPage />
          </Route>
          {/* 継続決済解約フォーム */}
          <Route exact path={process.env.PUBLIC_URL + '/reccurings/:payment_id/cancel/complete'}>
            <CancelSuccessPage />
          </Route>
          <Route path={process.env.PUBLIC_URL + '/reccurings/:payment_hash/cancel'}>
            <CancelRecurringPage />
          </Route>
          {/* 再決済フォーム */}
          <Route exact path={process.env.PUBLIC_URL + '/reccurings/:payment_id/payment/complete'}>
            <RePaymentSuccessPage />
          </Route>
          <Route path={process.env.PUBLIC_URL + '/reccurings/:payment_hash/payment'}>
            <RePaymentPage />
          </Route>
          {/* カード変更フォーム */}
          <Route exact path={process.env.PUBLIC_URL + '/reccurings/:payment_id/card/complete'}>
            <ChangeCardSuccessPage />
          </Route>
          <Route path={process.env.PUBLIC_URL + '/reccurings/:payment_hash/card'}>
            <ChangeCardPage />
          </Route>
          {/* ユーザー側 */}
          <Route path={process.env.PUBLIC_URL + '/credit/form'}>
            <RedirectToPaymentForm />
          </Route>
          <Route path={process.env.PUBLIC_URL + '/user/receipt_mail'}>
            <RedirectToOldCongrantReceipt />
          </Route>
          <Route path={process.env.PUBLIC_URL + '/user/'}>
            <RedirectToLogin />
          </Route>
          <Route path={process.env.PUBLIC_URL + '/new/receipt-mail'}>
            <RedirectToOldCongrant />
          </Route>
          <Route path={process.env.PUBLIC_URL + '/app'}>
            <AppPage />
          </Route>
          <Route component={NotFoundPage} />
        </Switch>
      </ConnectedRouter>
    </>
  );
}
